import React, { Component } from 'react';
import './App.scss';
import { Row, Col, Divider } from 'antd';
import img1 from './images/web-1.png';
import img2 from './images/web-2.png';
import img3 from './images/web-3.png';
import img4 from './images/web-4.png';
import img5 from './images/web-5.png';
import img6 from './images/web-6.png';
import bg from './images/bg.jpg';
import Messenger from './MessengerWrapper';
class App extends Component {
  loadForm = () => {
    return new Promise((resolve, reject) => {
      window.erxesSettings = {
        ...window.erxesSettings,
        forms: [{
          brand_id: "ZW2dSK",
          form_id: "B5uWQ7",
        }]
      };
      var script = document.createElement('script');
      script.src = "https://widgets.golomtbank.com/build/formWidget.bundle.js";
      script.async = true;

      var entry = document.getElementsByTagName('script')[0];
      entry.parentNode.insertBefore(script, entry);
      resolve();
    })
  }
  loadMessenger = () => {
    
  }
  componentDidMount() {
    this.loadForm().then(() => {
      this.loadMessenger();
    })
  }
  render() {
    return (
      <Row>
        <Messenger />
        <img src={bg} alt="cardbg" className="top-image" />
        <Row style={{ display: "flex", justifyContent: "center" }}>
          <Col xxl={16} xl={16} md={16} sm={20} xs={20} className="card-features">
            <Row>
              <h2 className="feature-title">Зэс картын давуу талууд</h2>
            </Row>
            <Row gutter={[30, 30]} style={{ marginBottom: "10px" }}>
              <Col className="feature" xxl={8} xl={8} lg={8} md={12} sm={12} xs={12}>
                <img src={img1} alt="zes-card-desc" />
              </Col>
              <Col className="feature" xxl={8} xl={8} lg={8} md={12} sm={12} xs={12}>
                <img src={img2} alt="zes-card-desc" />
              </Col>
              <Col className="feature" xxl={8} xl={8} lg={8} md={12} sm={12} xs={12}>
                <img src={img3} alt="zes-card-desc" />
              </Col>
              {/* </Row>
            <Row gutter={[10, 10]}> */}
              <Col className="feature" xxl={8} xl={8} lg={8} md={12} sm={12} xs={12}>
                <img src={img4} alt="zes-card-desc" />
              </Col>
              <Col className="feature" xxl={8} xl={8} lg={8} md={12} sm={12} xs={12}>
                <img src={img5} alt="zes-card-desc" />
              </Col>
              <Col className="feature" xxl={8} xl={8} lg={8} md={12} sm={12} xs={12}>
                <img src={img6} alt="zes-card-desc" />
              </Col>
            </Row>
            <Row>
              <p>Зэс кредит карт нь тив дэлхийн хаана ч байсан Монгол төгрөгөөрөө гүйлгээ хийх боломжийг харилцагчдад олгохоос гадна зээлийн
              уян хатан нөхцөл таны санхүүгийн хэрэгцээг бүрэн шийдвэрлэнэ.
              </p>
            </Row>
            <Divider type="horizontal" dashed className="custom-divider" />
            <Row>
              <h4><a target="_blank" rel="noopener noreferrer" href="https://www.golomtbank.com/citizen/product/153?m=7&__hstc=231999680.0bebf9370433cce12746720c00ff494b.1576135224411.1579600108331.1579658109547.17&__hssc=231999680.2.1579658109547&__hsfp=3874141456">ЭНД</a> дарж картын нөхцөлтэй танилцана уу.</h4>
              <p>
                Хэрэв та Зэс кредит карт эзэмшигчийн нэг болохыг хүсвэл доорх асуулгыг бөглөж хүсэлтээ илгээнэ үү. Манай борлуулалтын мэргэжилтэн
                тантай ажлын 2 өдөрт багтаан холбогдож, дэлгэрэнгүй мэдээлэл өгч, таны хүсэлтийг Голомт банкны танд ойрхон
                салбарт хуваарилах болно.
              </p>
            </Row>
            <Col style={{ display: "flex", justifyContent: "center" }}>
              <Col xxl={12} xl={12} md={12} sm={24} xs={24}>
                <div data-erxes-embed="B5uWQ7" style={{ width: "100%", minHeight: "600px" }}></div>
              </Col>
            </Col>
            <Divider className="custom-divider" dashed type="horizontal" />
            <p className="copyright">&copy; Golomt Bank, All rights reserved</p>
          </Col>
        </Row>
      </Row >
    );
  }
}

export default App;
